import { useRole } from '../context/RoleContext'

const AuthorizedComponent = ({ children, requiredRole }) => {
  const { role } = useRole()

  if (requiredRole && !requiredRole.includes(role)) {
    return null
  }

  return children
}

export default AuthorizedComponent
